module.exports = __webpack_public_path__ + "img/jcb.117214ef.svg";